import { connect } from 'react-redux';
import { Props } from './SubmitMenu';
import { toggleSubmitMenu } from '../../redux/actions';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'toggleSubmitMenu'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: DispatchProps = {
  toggleSubmitMenu,
};

export default connect(null, mapDispatchToProps);
